<template>
  <b-col cols="12" class="p-0">
    <div class="linearCardDiv pb-2">
      <div class="linearHeader">
        {{ chartData.chartHeader }}
      </div>
      <b-row class="chartRow" :style="chartStyle">
        <b-col v-if="chartData.chartHeader" cols="6" class="p-whiteSpace">
          <div class="text-start d-flex flex-column justify-content-end">
            <span v-if="chartData.chartDetail" class="text-muted text-truncate mb-0 linearDesc float-start">
              {{ chartData.chartDetail }}
            </span>
          </div>
        </b-col>
        <b-col :cols="chartData.chartHeader ? 6 : 12" class="">
          <SuperChart :chartData="chartData" />
        </b-col>
      </b-row>
    </div>
  </b-col>
</template>
<script>
import SuperChart from './SuperChart'
export default {
  components: {
    SuperChart,
  },
  props: {
    chartData: {},
    chartStyle: {
      type: String,
      default: ''
    }
  },
}
</script>

<style scoped>
.linearCardDiv {
  background: #ffffff;
  box-shadow: 0px 10px 20px rgba(18, 38, 63, 0.0313726);
  border-radius: 5px;
  padding: 20px 10px;
 
  display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
}
.chartRow {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  /* margin-top: 16px; */
  margin: 0 !important;
}
.linearHeader {
  font-size: 15px;
   display: flex;
}

.linearDesc {
  font-size: 13px;
}
.p-whiteSpace {
  white-space: nowrap !important;
}

::v-deep .linearCardDiv .card-body {
  width: 100%;
  justify-content: center;
  padding: 11px 10px !important;
}
</style>
